<template>
    <div class="">
        <custom-alert v-if="displayAlert == true" :message="alertMessage" v-on:showedAlert="resetAlert"></custom-alert>
        <div class="row">
            <div class="col-md-12 mt-3 mb-4">
                <div class="card club-info">
                    <div class="card-header register-title">
                        <div class="row" v-if="current_members_default">
                            <div class="col-md-12">
                                <div class="alert alert-info alert-dismissible" role="alert">
                                    <strong>Current Members</strong> are auto filtered. Press "Reset" button if you want
                                    to see all players
                                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <h3 v-html="titleLabel"></h3>
                            </div>
                            <div class="col-md-6 text-right">
                                <div class="col-md-12 m-roaster-btns" style="margin-top: 10px">
                                    <b-button variant="outline-primary mr-1" :disabled="exportPDFProgress"
                                        @click="exportConfirm()">
                                        <i class="fa"
                                            :class="exportPDFProgress ? 'fa-circle-notch fa-spin' : 'fa-file-export'"></i>
                                        Export
                                    </b-button>
                                    <b-button class="outline-primary btn-darkblue mr-1"
                                        :class="{ 'filter-applied': filtersApplied }" v-b-modal.modal-member-report>
                                        <i class="fas fa-sliders-h"></i> Filters
                                    </b-button>
                                    <b-button class="outline-primary btn-darkblue" @click="refreshList"
                                        v-if="filtersApplied">
                                        <i class="fas fa-redo"></i> Reset
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body addnewbutn">
                        <TableLoaderV1 v-if="!tableEnable" />
                        <div class="memberdetail-section" v-show="tableEnable">
                            <div class="row mb-3">
                                <div class="col-md-12">
                                    <table id="list_table" class="table table-sm table-hover" style="width:100%">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Email</th>
                                                <th>Age</th>
                                                <th>Member#</th>
                                                <th>Membership <br>Type</th>
                                                <th>Membership <br>Status / <br>Expiration<a href="javascript:void(0);"
                                                        v-if="getSiteProps('clubMemberRoster.membershipStatusIcon')"
                                                        v-b-modal.statusInfo><img
                                                            v-bind:src="'/dist/img/memberregistration/tooltip-icon-small.png'"
                                                            alt="tooltipicon" style="width: 20px" /></a></th>
                                                <th class="none">Primary <br>Sport <br>Discipline</th>
                                                <th>Safe Sport <br>Training <br>Status / <br>Expiration</th>
                                                <th>
                                                    Background <br>Screening <br>Status / <br>Expiration
                                                    <template v-if="getSiteProps('tooltips.backgroundScreening')">
                                                        <div class="d-inline" id="bgscreen-tooltip"
                                                            v-b-tooltip.hover="{ customClass: 'bgscreen-tooltip' }">
                                                            <img v-bind:src="'/dist/img/memberregistration/tooltip-icon-small.png'"
                                                                alt="tooltipicon" style="width: 20px" />
                                                        </div>
                                                        <b-tooltip custom-class="bgscreenTooltip"
                                                            target="bgscreen-tooltip" class="white">
                                                            <p class="mb-0"
                                                                v-html="getSiteProps('tooltips.backgroundScreening')">
                                                            </p>
                                                        </b-tooltip>
                                                    </template>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td colspan="12">&nbsp;</td>
                                            </tr>
                                            <tr>
                                                <td colspan="12">&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="statusInfo" size="xl" title="Membership Status Types" hide-footer>
            <div class="table-responsive">
                <table class="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>What This Means</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Current</td>
                            <td>Paid dues, Signed Waiver, Completed Safe Sport training </td>
                            <td>All membership requirements are met and may participate in all sanctioned activities.
                            </td>
                        </tr>
                        <tr>
                            <td>Expired</td>
                            <td>Dues not paid</td>
                            <td>Member needs to renew as an active (insured) member to be eligible to participate in
                                sanctioned
                                activity.</td>
                        </tr>
                        <tr>
                            <td>Waiting – Need Safe Sport</td>
                            <td>Paid dues, Signed Waiver but has not completed Safe Sport training </td>
                            <td>Membership is pending successful completion of Safe Sport training within 30 days of
                                joining as
                                a new member. May still participate in sanctioned activities during this period. </td>
                        </tr>
                        <tr>
                            <td>Pending – Safe Sport </td>
                            <td>Paid dues, Signed Waiver but has not completed Safe Sport training after 30 days</td>
                            <td>Not eligible to participate in sanctioned events (tournaments) until Safe Sport training
                                is
                                completed. The 30-day grace period to complete Safe Sport training after joining as a
                                new member
                                has expired. </td>
                        </tr>
                        <tr>
                            <td>Pending – Signed Waiver </td>
                            <td>Paid dues but has not signed Waiver</td>
                            <td>Membership is pending signed Annual Membership Waiver. Not eligible to participate in
                                sanctioned
                                activity until waiver is signed. Please go into your individual membership dashboard to
                                sign the
                                Waiver.</td>
                        </tr>
                        <tr>
                            <td>Pending – Safe Sport & Signed Waiver</td>
                            <td>Paid dues but has not signed Waiver or completed Safe Sport training</td>
                            <td>Membership is pending successful completion of Safe Sport Training and signed Annual
                                Membership
                                Waiver. Not eligible to participate until Waiver is signed. Please go into your
                                individual
                                membership dashboard to sign the Waiver. New members have 30 days to complete Safe Sport
                                training.</td>
                        </tr>
                        <tr>
                            <td>Suspended</td>
                            <td>N/A</td>
                            <td>Ineligible to participate in any capacity with any USA Water Ski & Wake Sports club or
                                in any
                                USA Water Ski & Wake Sports sanctioned activity.</td>
                        </tr>
                        <tr>
                            <td>Deceased</td>
                            <td>N/A</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-modal>
        <b-modal id="modal-member-report" v-bind:hide-footer="true" ref="modal-member-report" size="lg"
            title="Advanced Search">
            <form ref="form" method="post" @submit.prevent="advancedSearch()">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label">Membership Expiration (From)</label>
                            <div class="input-group birthdate">
                                <div class="birthdaypicker">
                                    <date-pick v-model="searchForm.membership_expiration_from" :format="'MM/DD/YYYY'"
                                        :displayFormat="'MM/DD/YYYY'" v-mask="'##/##/####'"
                                        :parseDate="parseDatePick"></date-pick>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label">Membership Expiration (To)</label>
                            <div class="input-group birthdate">
                                <div class="birthdaypicker">
                                    <date-pick v-model="searchForm.membership_expiration_to" :format="'MM/DD/YYYY'"
                                        :displayFormat="'MM/DD/YYYY'" v-mask="'##/##/####'"
                                        :parseDate="parseDatePick"></date-pick>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="subdomain != 'alliancefastpitch'">
                        <div class="form-group">
                            <label class="form-label">Safe Sport Expiration (From)</label>
                            <div class="input-group birthdate">
                                <div class="birthdaypicker">
                                    <date-pick v-model="searchForm.safe_sport_expiration_from" :format="'MM/DD/YYYY'"
                                        :displayFormat="'MM/DD/YYYY'" v-mask="'##/##/####'"
                                        :parseDate="parseDatePick"></date-pick>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6" v-if="subdomain != 'alliancefastpitch'">
                        <div class="form-group">
                            <label class="form-label">Safe Sport Expiration (To)</label>
                            <div class="input-group birthdate">
                                <div class="birthdaypicker">
                                    <date-pick v-model="searchForm.safe_sport_expiration_to" :format="'MM/DD/YYYY'"
                                        :displayFormat="'MM/DD/YYYY'" v-mask="'##/##/####'"
                                        :parseDate="parseDatePick"></date-pick>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label class="form-label">Membership Status</label>
                            <!-- <input type="text" class="form-control"> -->
                            <!-- <select id="status" name="status" class="form-control" v-model="searchForm.membership_status">
                                <option value="">All</option>
                                <template v-for="(value, id) in membershipStatus">
                                    <option v-if="id > 0" :value="value" :key="id">{{ value }}</option>
                                </template>
                            </select> -->
                            <Select2 v-model="searchForm.membership_status" name="status" id="status"
                                :options="membershipStatusSelect2"
                                :settings="{ multiple: true, placeholder: 'Click to select one or multiple' }" />
                        </div>
                    </div>
                    <div class="col-md-6" v-if="subdomain == 'alliancefastpitch'">
                        <div class="form-group">
                            <label class="form-label">Roster Status</label>
                            <Select2 v-model="searchForm.roster_status" name="roster_status" id="roster_status"
                                :options="roster_status"
                                :settings="{ multiple: true, placeholder: 'Click to select one or multiple' }" />
                        </div>
                    </div>
                    <div class="col-md-6" v-if="subdomain != 'alliancefastpitch'">
                        <div class="form-group">
                            <label class="form-label">Safe Sport Status</label>
                            <!-- <input type="text" class="form-control"> -->
                            <!-- <select id="safe_sport_status" name="safe_sport_status" class="form-control" v-model="searchForm.safe_sport_status">
                                <option value="">All</option>
                                <option value="Not Started">Not Started</option>
                                <option value="In Progress">In Progress</option>
                                <option value="Complete">Complete</option>
                                <option value="Expired">Expired</option>
                            </select> -->
                            <Select2 v-model="searchForm.safe_sport_status" name="safe_sport_status"
                                id="safe_sport_status"
                                :options="[{ id: 0, text: 'Not Started' }, { id: 1, text: 'In Progress' }, { id: 3, text: 'Complete' }, { id: 13, text: 'Expired' }]"
                                :settings="{ multiple: true, placeholder: 'Click to select one or multiple' }" />
                        </div>
                    </div>
                    <div class="col-md-12 modal-searchbtn text-center">
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary btn-blue">Search</button>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
        <b-modal id="export-confirmation" size="md" title="Export" ok-only ok-title="Export" @ok="exportPDF">
            <div class="form-group">
                <label for="exclude_expired" class="control-label">You want to exclude expired members ?</label><br>
                <input type="radio" name="exclude_expired" value="1" v-model="exclude_expired"> Yes <br>
                <input type="radio" name="exclude_expired" value="0" v-model="exclude_expired"> No <br>
            </div>
        </b-modal>
    </div>
</template>
<script>
import CustomAlert from "../CustomAlert";
import axios from 'axios';
import * as $ from 'jquery';
import "datatables.net-responsive-dt/js/responsive.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import "datatables.net-fixedheader/js/dataTables.fixedHeader.js";
import DatePick from "vue-date-pick";
import TableLoaderV1 from "../loaders/TableLoaderV1";

export default {
    name: "clubroaster",
    components: { TableLoaderV1, CustomAlert, DatePick },
    data() {
        return {
            titleLabel: this.$route.meta.title,
            rostersInfo: [],
            sortBy: 'last_name',
            sortDesc: false,
            safesportRefreshing: false,
            exportProgress: false,
            exportPDFProgress: false,
            table: null,
            filtersApplied: false,
            searchForm: {
                membership_status: [],
                roster_status: [],
                membership_expiration_from: null,
                membership_expiration_to: null,
                safe_sport_status: [],
                safe_sport_expiration_from: null,
                safe_sport_expiration_to: null
            },
            showAllhidden: true,
            showActive: false,
            status: '',
            button: {
                SearchButton: 'Search'
            },
            datepicker2: true,
            exclude_expired: 0,
            UpdateCLub: {},
            club_reg_status: "Current",
            current_members_default: null,
            tableEnable: false,
        }
    },
    methods: {
        resetAlert() {
            this.displayAlert = false;
        },
        loadRostersInfo(value = 0) {
            if (value) {
                this.safesportRefreshing = true;
            }
            if (this.table == null) {
                var self = this;
                this.tableEnable = true;
                if (self.current_members_default) {
                    this.filtersApplied = true;
                    self.searchForm.membership_status = [1];
                }
                this.table = $('#list_table').DataTable({
                    rowReorder: {
                        selector: 'td:nth-child(2)'
                    },
                    dom: "lfrtip",
                    scrollCollapse: true,
                    scrollY: '50vh',
                    processing: true,
                    serverSide: true,
                    bFilter: true,
                    responsive: true,
                    pageLength: 200,
                    "aLengthMenu": [[10, 50, 100, 200],
                    [10, 50, 100, 200]],
                    ajax: {
                        url: process.env.VUE_APP_URL + "api/volunteers/club/" + this.$route.params.id + "/member-roster",
                        type: 'get',
                        headers: this.adminHeaders,
                        data: function (d) {
                            d.dt = 1;
                            d.refresh = self.safesportRefreshing;
                            d.filters = self.searchForm;
                            d.guest = self.$route.meta.listGuestOnly;
                        }
                    },
                    columns: [
                        {
                            data: 'full_name', name: 'full_name', render: (data, type, row, meta) => {
                                var contact = row.contact_type ? row.contact_type['contact_type'] : 'N/A';
                                if (contact != 'N/A' && contact == 6 && this.subdomain == 'waterski') {
                                    return data + '<br><span style="color:red">*** Show Director ***</span>';
                                } else if (contact != 'N/A' && contact == 7 && this.subdomain == 'waterski') {
                                    return data + '<br><span style="color:red">*** Ast Show Director ***</span>';
                                } else {
                                    return data;
                                }
                            }
                        },
                        { data: 'email', name: 'email', render: (data) => { return data || "N/A"; } },
                        { data: 'age', name: 'age', render: (data) => { return data || "N/A"; } },
                        { data: 'confirmation_code', name: 'confirmation_code', render: (data) => { return data || "N/A"; } },
                        {
                            data: 'membership_name', name: 'membership_name', render: (data, type, row, meta) => {
                                if (row.membership_info_link)
                                    return `<a href="https://www.usawaterski.org/membership" target="_blank">${data}</a>` || "N/A";
                                else
                                    return data || "N/A";
                            }
                        },
                        { data: 'member_status', name: 'member_status', width: 100, render: (data) => { return data || "N/A"; } },
                        { data: 'sports_discipline', name: 'sports_discipline', render: (data) => { return data || "N/A"; } },
                        { data: 'safesport', name: 'safesport', width: 100, render: (data) => { return data || "N/A"; } },
                        { data: 'background_screening', name: 'background_screening', width: 100, render: (data) => { return data || "N/A"; } }
                    ],
                    fnDrawCallback: function (settings) {
                        let response = settings.json;
                        if (self.safesportRefreshing === true) {
                            self.safesportRefreshing = false;
                        }
                        if (response?.club_name) {
                            self.titleLabel = "Member Roster of " + response?.club_name;
                        }
                    }
                });
            } else {
                this.table.draw();
            }
        },
        exportPDF() {
            this.exportPDFProgress = true;
            axios.post(
                this.basePath + 'api/volunteers/club/'+this.$route.params.id+'/member-roster/export',
                { filters: this.searchForm, exclude_expired: this.exclude_expired },
                { headers: this.adminHeaders, responseType: 'blob' }
            )
                .then(function (response) {
                    // window.open(URL.createObjectURL(response.data));
                    this.exportPDFProgress = false;
                    this.exclude_expired = 0;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'member-roster.pdf'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }.bind(this))
                .catch(function (error) {
                    this.exportPDFProgress = false;
                    console.log(error);
                });
        },
        advancedSearch() {
            this.current_members_default = false;
            this.table.draw();
            this.filtersApplied = true;
            this.$refs['modal-member-report'].hide();
        },
        refreshList(event) {
            this.current_members_default = false;
            this.searchForm = {
                membership_status: [],
                roster_status: [],
                membership_expiration_from: null,
                membership_expiration_to: null,
                safe_sport_status: [],
                safe_sport_expiration_from: null,
                safe_sport_expiration_to: null
            };
            $("#selectall").prop("checked", false);
            this.table.ajax.reload();
            this.filtersApplied = false;
        },
        loadClubInfo() {
            axios.get(this.basePath + "api/club/info", { headers: this.clubHeaders })
                .then((response) => {

                    const resp = response.data.data;

                    this.UpdateCLub.ageDivision = resp.ageDivision.id;
                    this.UpdateCLub.league = resp.memberLeageue.id;
                    this.club_reg_status = resp.registration.reg_status;

                    this.playerTransferForm.age_division = this.UpdateCLub.ageDivision;
                    this.playerTransferForm.league = this.UpdateCLub.league;
                    this.getTeam();
                    //alliance fast pitch profile handler
                    if (!this.getSiteProps('general.member_profile_addition_info') && this.getSiteProps('general.member_profile_addition_info') != undefined) {
                        this.clubAdditionalInfoView = false;
                    }

                })
                .catch((error) => {
                    console.log(error);
                });
        },
        validate() {
            this.errors = {};
            if (this.searchForm.MemberExpirationStartDate != undefined || this.searchForm.MemberExpirationEndDate != undefined) {
                if (this.searchForm.searchFormat === undefined) {
                    this.errors.searchFormat = "This field is required";
                    return this.valid = false;
                }
            }
            if (this.searchForm.searchFormat != undefined) {
                if (this.searchForm.MemberExpirationStartDate === undefined) {
                    this.errors.MemberExpirationStartDate = "This field is required";
                    return this.valid = false;
                }
                else if (this.searchForm.searchFormat == "between") {
                    if (this.searchForm.MemberExpirationStartDate === undefined) {
                        this.errors.MemberExpirationStartDate = "This field is required";
                        return this.valid = false;
                    }
                    if (this.searchForm.MemberExpirationEndDate === "" || this.searchForm.MemberExpirationEndDate === undefined) {
                        this.errors.MemberExpirationEndDate = "This field is required";
                        return this.valid = false;
                    }
                }
                return this.valid = true;
            }
            return this.valid = true;
        },
        getSafeSportStatus() {
            axios.get(this.basePath + 'api/getSafeSportStatus')
                .then(response => {
                    this.safesportStatus = response.data.data;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        onChange() {
            if (this.searchForm.searchFormat != '' && this.searchForm.searchFormat != 'between') {
                this.datepicker2 = false;
            } else {
                this.datepicker2 = true;
            }
        },
        exportConfirm() {
            if (this.current_members_default === false) {
                this.$bvModal.show('export-confirmation')
            } else {
                this.exportPDF();
            }
        }
    },
    mounted() {
        this.showLoader = true;
        const retry = setInterval(() => {
            this.current_members_default = this.getSiteProps('clubMemberRoster.current_members_default');
            if (this.current_members_default !== undefined) {
                this.loadRostersInfo();
                clearInterval(retry);
            }
        }, 2000);
        this.getSafeSportStatus();
        this.getMembershipStatus();
        var self = this;
    },
    watch: {
        selected(newValue, oldValue) {
            // Handle changes in individual flavour checkboxes
            if (newValue.length === 0) {
                this.indeterminate = false
                this.allSelected = false
            } else if (newValue.length === this.rostersInfo.length) {
                this.indeterminate = false
                this.allSelected = true
            } else {
                this.indeterminate = true
                this.allSelected = false
            }
        }
    },
    computed: {
        club_member_delete_option: function () {
            return this.getSiteProps('clubMemberRoster.club_member_delete_option');
        },
        membershipStatusSelect2() {
            var list = [];
            this.membershipStatus.forEach((item, index) => {
                if (index > 0 && item != '')
                    list.push({ id: index, text: item });
            });
            return list;
        }
    }
}
</script>
<style>
body.modal-open.cke_dialog_open #modal-bulk-email___BV_modal_outer_ #modal-bulk-email {
    display: none !important;
}
</style>
